import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useRestaurants } from '../../../contexts/RestaurantsContext';
import { Carousel } from 'react-responsive-carousel';  // Import Carousel component
import "react-responsive-carousel/lib/styles/carousel.min.css";  // Carousel styling
import VideoPlayer from '../../../components/common/VideoPlayer/VideoPlayer';
import Map from '../Map/Map.js'
import './Restaurants.css'
import about5 from '../../../assets/about5.png';
import hibachi from '../../../assets/hibachi.png'

const Restaurants = () => {
    const { restaurantId } = useParams(); 
    const { restaurantData, setRestaurantData, restaurants } = useRestaurants();

    useEffect(() => {
        const selectedRestaurant = restaurants[restaurantId];
        
        if (selectedRestaurant.name && restaurantData.name !== selectedRestaurant.name) {
            setRestaurantData(selectedRestaurant);
        }
    }, [restaurantId, restaurants, restaurantData, setRestaurantData]);
    

    if (!restaurantData || !restaurantData.name) {
        return <div>Restaurant not found</div>;
    }

    return (
        <div className="restaurants-page">
            {restaurantData.videos ? (
                <div className="video-container">
                    <VideoPlayer src={restaurantData.videos} />
                </div>
            ) : (
                <div className="no-video-container">
                    <div className="no-video-content">
                        <h1>{restaurantData.name}</h1>
                    </div>
                </div>
            )}
            {/* <div className="restaurant">
                <h1>{restaurantData.name}</h1>
                <p>{restaurantData.description}</p>
            </div> */}
            <div className="restaurantMenu-container">



            {/* <Map/> */}
            <div className="order-flex">
                    <div className="order-content">
                        <h2>Bringing the Finest Asian Flavors</h2>
                        <p>Freshly Prepared, Made to Perfection.</p>
                        <Link to={restaurantData.doordash}>ORDER ONLINE</Link>
                    </div>
                    <div className="order-image"></div>
                </div>

            <div className="menu-flex">
                    <div className="menu-content">
                        <h2>Our Culinary Excellence</h2>
                        <p>to your table</p>
                        <Link to={`/restaurants/${restaurantId}/menu`}>View Menu</Link>
                    </div>
                    <div className="menu-image"></div>
                </div>

                <div className="aboutUs-flex">
                    <div className="aboutUs-image"></div>
                    <div className="aboutUs-content">
                        <h2>Our Philosophy</h2>
                        <p>Where passion for flavor meets dedication to hospitality</p>
                        <Link to={`/restaurants/${restaurantId}/about`}>About Us</Link>
                    </div>
                </div>

                <div className="map-flex">
                    <div className="map-content">
                        <h2>{restaurantData.name} Near You</h2>
                        <Link to={`/restaurants/${restaurantId}/map`}>View Map</Link>
                    </div>
                    <div className="map-image"></div>
                </div>

                {/* Carousel for Reviews */}
                <div className="reviews-container">
                {restaurantData.review && restaurantData.review.length > 0 && (
                    <div className="reviews-carousel">
                        <h2>Loved By Reviewers</h2>
                        <Carousel showArrows={true} autoPlay={true} infiniteLoop={true}>
                            {restaurantData.review.map((review, index) => (
                                <div key={index} className="review-slide">
                                    <h3>{review.name}</h3>
                                    <div className="reviews-text">
                                        <div className="reviews-quoteLeft fa-solid fa-quote-left"></div>
                                        <p>{review.review}</p>
                                        <div className="reviews-quoteRight fa-solid fa-quote-right"></div>
                                    </div>
                                    <div className="review-star">
                                        {'★'.repeat(review.star)}
                                        {'☆'.repeat(5 - review.star)}
                                    </div>
                                    {/* <a href={review.url} target="_blank" rel="noopener noreferrer">Read more on Yelp</a> */}
                                </div>
                            ))}
                        </Carousel>
                    </div>
                )}
                </div>

            </div>
        </div>
    );
};

export default Restaurants;
